import React from "react";
import TypeAnimation from "react-type-animation";
import Resume from "../resume/Resume";

function Home() {
  return (
    <>
      <div className="home-page">
        <h1>
          <span className="fst-italic">Hi, I am</span>
          <br />
          Herminigildo Jr Quiano
        </h1>
        <TypeAnimation
          cursor={false}
          sequence={["Junior Software Developer", 3000]}
          wrapper="h3"
          repeat={Infinity}
          className="roboto-mono type-green"
        />
        <Resume />
      </div>
    </>
  );
}

export default Home;
